import messageComponent from './message.component'
import MessageAll from './all'
import MessageCreate from './create'
import MessageEdit from './edit'
import DuplicateMessage from './duplicate_message'

let messageModule = angular.module('message', [
    MessageAll,
    MessageCreate,
    MessageEdit,
    DuplicateMessage
])

.component('message', messageComponent)
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('message.all', {
      url: '/all/:page',
      component: 'messageall'
    })
    .state('message.create', {
      url: '/create',
      component: 'messagecreate'
    })
    .state('message.edit', {
      url: '/edit/:id',
      component: 'messageedit'
    })
    .state('message.duplicateMessage', {
      url: '/duplicate-message',
      component: 'duplicateMessage'
    })
})

.name;

export default messageModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/index.js